export * from './edit-tappa-modal.component';
